import { Button } from "@/components/ui/button";
import { Camera, FileText, Receipt, Sparkles, Upload, X } from "lucide-react";

export default function UploadPhase({
  scanType,
  docType,
  setDocType,
  photos,
  addFiles,
  removePhoto,
  onAnalyze,
  fileRef,
  cameraRef,
}) {
  return (
    <div className="space-y-4">
      {scanType === "product" && (
        <div className="flex items-center gap-2 p-1 rounded-lg bg-[#F4F1ED] border border-[#EAE7E1]">
          <button
            type="button"
            data-testid="doc-type-receipt"
            onClick={() => setDocType("receipt")}
            className={`flex-1 flex items-center justify-center gap-2 py-2 px-3 rounded-md text-sm font-medium transition-all ${
              docType === "receipt"
                ? "bg-white text-[#2E4A3B] shadow-sm"
                : "text-[#5C5F5A] hover:text-[#2E4A3B]"
            }`}
          >
            <Receipt size={14} />
            Scontrino
          </button>
          <button
            type="button"
            data-testid="doc-type-ddt"
            onClick={() => setDocType("ddt_invoice")}
            className={`flex-1 flex items-center justify-center gap-2 py-2 px-3 rounded-md text-sm font-medium transition-all ${
              docType === "ddt_invoice"
                ? "bg-white text-[#2E4A3B] shadow-sm"
                : "text-[#5C5F5A] hover:text-[#2E4A3B]"
            }`}
          >
            <FileText size={14} />
            DDT / Fattura
          </button>
        </div>
      )}

      <input
        ref={cameraRef}
        type="file"
        accept="image/*"
        capture="environment"
        multiple
        className="hidden"
        data-testid="receipt-camera-input"
        onChange={(e) => addFiles(e.target.files)}
      />
      <input
        ref={fileRef}
        type="file"
        accept="image/jpeg,image/png,image/webp"
        multiple
        className="hidden"
        data-testid="receipt-file-input"
        onChange={(e) => addFiles(e.target.files)}
      />

      {photos.length > 0 ? (
        <div className="space-y-3">
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
            {photos.map((p, i) => (
              <div
                key={p.id}
                data-testid={`receipt-thumb-${i}`}
                className="relative aspect-square rounded-lg overflow-hidden border border-[#EAE7E1] bg-[#F4F1ED] group"
              >
                <img src={p.preview} alt={`Foto ${i + 1}`} className="w-full h-full object-cover" />
                <div className="absolute top-1 left-1 text-[10px] font-mono font-semibold text-[#2E4A3B] bg-white/95 border border-[#EAE7E1] px-1.5 py-0.5 rounded">
                  Foto {i + 1}
                </div>
                <Button
                  size="icon"
                  variant="outline"
                  onClick={() => removePhoto(p.id)}
                  className="absolute top-1 right-1 h-6 w-6 bg-white/95"
                  data-testid={`receipt-remove-${i}`}
                >
                  <X size={12} />
                </Button>
              </div>
            ))}
            <button
              type="button"
              data-testid="receipt-add-more-btn"
              onClick={() => {
                if (/Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)) {
                  cameraRef.current?.click();
                } else {
                  fileRef.current?.click();
                }
              }}
              className="aspect-square rounded-lg border-2 border-dashed border-[#EAE7E1] bg-[#F9F8F6] hover:border-[#2E4A3B] hover:bg-[#E8F3EC] flex flex-col items-center justify-center gap-2 text-[#5C5F5A] hover:text-[#2E4A3B] transition-all"
            >
              <Camera size={20} />
              <span className="text-xs font-medium">Aggiungi</span>
            </button>
          </div>

          <Button
            data-testid="receipt-analyze-btn"
            onClick={onAnalyze}
            className="w-full h-12 bg-[#2E4A3B] hover:bg-[#21382C] text-white"
          >
            <Sparkles size={16} className="mr-2" />
            Leggi {photos.length} {photos.length === 1 ? "foto" : "foto"} con AI
          </Button>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <button
            data-testid="receipt-camera-btn"
            onClick={() => cameraRef.current?.click()}
            className="flex flex-col items-center justify-center gap-3 p-8 rounded-xl border-2 border-dashed border-[#EAE7E1] bg-[#F9F8F6] hover:border-[#2E4A3B] hover:bg-[#E8F3EC] transition-all"
          >
            <div className="h-14 w-14 rounded-2xl bg-[#2E4A3B] text-white flex items-center justify-center">
              <Camera size={26} />
            </div>
            <div className="text-center">
              <div className="font-semibold text-sm">Scatta una o più foto</div>
              <div className="text-xs text-[#8E918C] mt-1">Con la fotocamera</div>
            </div>
          </button>
          <button
            data-testid="receipt-upload-btn"
            onClick={() => fileRef.current?.click()}
            className="flex flex-col items-center justify-center gap-3 p-8 rounded-xl border-2 border-dashed border-[#EAE7E1] bg-[#F9F8F6] hover:border-[#2E4A3B] hover:bg-[#E8F3EC] transition-all"
          >
            <div className="h-14 w-14 rounded-2xl bg-[#E5E1D8] text-[#2E4A3B] flex items-center justify-center">
              <Upload size={26} />
            </div>
            <div className="text-center">
              <div className="font-semibold text-sm">Carica più file</div>
              <div className="text-xs text-[#8E918C] mt-1">JPEG, PNG, WEBP</div>
            </div>
          </button>
        </div>
      )}

      <div className="text-xs text-[#8E918C] text-center pt-2">
        Puoi aggiungere più foto: l&apos;AI le elabora insieme e tu rivedi tutto in un colpo solo.
      </div>
    </div>
  );
}
